import { getSangjoQuotations } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import CallFixedButton from "@/components/common/CallFixedButton";
import LoadingProvider from "@/components/Provider/LoadingProvider";
import { Box } from "@chakra-ui/react";
import {
  Button,
  colors,
  GLOBAL_MAX_WIDTH,
  HStack,
  queryKeys,
  TopBanner,
  useResponsive,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import GuideSlider from "./components/MatchRecommendations/GuideSlider";
import HeadBanner from "./components/MatchRecommendations/HeadBanner";
import RecommendationCardListCarousel from "./components/MatchRecommendations/RecommendationCardListCarousel";

/**
 * `/match/recommendations`(복수) — 견적 목록. 하단 탭 "고이의 추천"과 랜딩 breadcrumb의
 * 목적지다.
 *
 * **폴백 목적지로 쓰지 말 것.** 예전에는 결과 페이지가 Quotation id를 못 구했을 때
 * 여기로 떨어뜨렸는데, 이제 `/match/recommendation`(단수)이 id 없이 열리므로 그럴 이유가
 * 없다. 게다가 이 화면이 부르는 `GET /sangjo_quotations/`는 서버에서
 * `add_quotation(is_triggered_by_list_view=True)`를 태워 **야간 수신 동의를 True로 강제**한다.
 * 실패 경로로 쓰면 사용자가 동의한 적 없는 값이 조용히 켜진다.
 */
function MatchRecommendationsContainer() {
  const { isBiggerThanLg } = useResponsive();
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const { data, isLoading } = useQuery(queryKeys.sangjoQuotation, () => getSangjoQuotations(), {
    enabled: isLoggedIn,
  });
  const router = useRouter();
  const isCTAButtonVisible = useMemo(() => {
    if (!isLoggedIn) return true;
    if (data && data.quotations.length > 0) {
      return false;
    } else {
      return true;
    }
  }, [isLoggedIn, data]);
  return (
    <LoadingProvider isLoading={isLoading}>
      <VStack width="100%" alignItems="center">
        <CallFixedButton />
        <VStack width="100%" maxWidth={GLOBAL_MAX_WIDTH} alignItems="center">
          <TopBanner path="mtch_recomm_lst" />

          <VStack width="100%" maxWidth={GLOBAL_MAX_WIDTH}>
            <HeadBanner />
          </VStack>

          <HStack
            width="100%"
            justifyContent="space-between"
            maxWidth={isBiggerThanLg ? "800px" : "480px"}
          >
            <Box width="100%" pb="120px">
              <VStack gap="8px" padding="16px 0 8px" width="100%">
                {isCTAButtonVisible ? (
                  <>
                    <Box padding="6px 24px" className="caption_12_m gray600" textAlign="center">
                      장례식장, 장지 비용까지 한번에 알아보세요
                    </Box>
                    <Box padding="0 24px" width="100%" overflow="hidden">
                      <Button
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: colors.orange650,
                        }}
                        event={{
                          newGtm: {
                            path: "mtch_recomm_lst",
                            trigger_and_target: "CTA-uv_match_request",
                          },
                        }}
                        onClick={() => {
                          router.push("/match/request");
                        }}
                        className="button_14_sb white"
                      >
                        장례 서비스 한번에 추천받기
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box padding="0 24px" className="body_14_m gray600">
                      어떤 서비스를 선택해야 할까요?
                    </Box>
                    <Box width="100%" overflow="hidden">
                      <GuideSlider />
                    </Box>
                  </>
                )}
              </VStack>
              <RecommendationCardListCarousel />
            </Box>
          </HStack>
        </VStack>
      </VStack>
    </LoadingProvider>
  );
}

export default MatchRecommendationsContainer;
